import { navigate } from '@/features/routing';

interface IAppLinkProps
  extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'onClick' | 'className'> {
  href: string;
  children: React.ReactNode;
  className?: string;
  /* If the onClick function returns true (handled), the link will not perform a navigation. */
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => Promise<boolean> | boolean;
  replace?: boolean;
}

/**
 * AppLink is a link that navigates to a new page using the NavigationProvider.
 */
export const AppLink = ({
  href,
  children,
  className,
  onClick,
  replace,
  ...rest
}: IAppLinkProps) => {
  const handleClick = async (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    let handled = false;
    if (onClick) {
      handled = await Promise.resolve(onClick(event)).catch(() => false);
    }
    if (!handled) {
      navigate(href, { replace });
    }
  };

  return (
    <a href={href} onClick={handleClick} className={className} {...rest}>
      {children}
    </a>
  );
};
